export default "__VITE_ASSET__D0oSf6id__"